<template>

  <li :id="'cl-'+secret.id"
      @click="copy(secret.id)"
      class="list-group-item list-group-item-action auth"
      :class="{'purple-text' : (!secret.items) }"
  >

    <div class="d-flex w-100 justify-content-between">
      <p class="auth-name">{{secret.name}}</p>

      <button v-if="favoriteFeature" :disabled="!canFavorite" type="button" @click.stop="favorite"
              class="auth-fav">
        <star-outline-icon v-if="!favorited"/>
        <star-icon v-if="favorited"/>
      </button>

      <loading-icon class="spin" v-if="!secret.items"/>

      <a :href="secretUrl(secret.id)" v-if="secret.items" class="auth-ext" @click.stop=""
         target="_blank">Open
        <open-in-new-icon/>
      </a>

    </div>
    <div class="input-group">

      <input :id="'as-'+secret.id" :type="fieldType(secret.id)" class="form-control"
             disabled="disabled" :value="mask">

      <div class="input-group-append">

        <button v-if="!alwaysShowOtp" class="btn btn-outline-secondary"
                @click.stop="toggleShowOtp(secret.id)"
                type="button">
                    <span v-if="!showOtp">
                        <eye-icon/>
                    </span>
          <span v-if="showOtp">
                        <eye-off-icon/>
                    </span>
        </button>
        <button type="button" class="btn btn-outline-secondary" @click.stop="copy(secret.id)">
          <content-copy-icon></content-copy-icon>
        </button>

      </div>

    </div>

    <span class="chip"
          :class="{'white-text' : (time <= 5), 'orange' : (time <= 5 && time >= 3), 'red' : (time <= 2),}">{{ time
            }}</span>

  </li>


</template>

<script>
  import {mapActions, mapGetters} from 'vuex';

  import EyeIcon from "vue-material-design-icons/Eye";
  import EyeOffIcon from "vue-material-design-icons/EyeOff";
  import ContentCopyIcon from "vue-material-design-icons/ContentCopy";
  import LoadingIcon from "vue-material-design-icons/Loading";
  import CloseCircleIcon from "vue-material-design-icons/CloseCircle";

  import * as Toastr from 'toastr';
  import OpenInNewIcon from "../../../node_modules/vue-material-design-icons/OpenInNew.vue";
  import StarOutlineIcon from "../../../node_modules/vue-material-design-icons/StarOutline.vue";
  import StarIcon from "../../../node_modules/vue-material-design-icons/Star.vue";

  Toastr.options.timeout = 1500;

  export default {
    name: 'authenticator',
    props: {
      secretId: {
        type: Number,
        default: null,
      },
      time: {
        type: Number,
        default: null,
      }
    },
    watch: {
      time: {
        handler: function (val) {  // eslint-disable-line
          if (val === 30 || !this.dispatched) {
            this.generateOtps();
          }
        },
        immediate: true,
      }
    },
    components: {
      StarIcon,
      StarOutlineIcon,
      OpenInNewIcon,
      EyeIcon,
      EyeOffIcon,
      ContentCopyIcon,
      LoadingIcon,
      CloseCircleIcon,
    },
    data() {
      return {
        dispatched: false,
        otp: false,
      };
    },
    computed: {
      ...mapGetters({
        url: 'auth/url',
        offlineMode: 'auth/offlineMode',
        secrets: 'authenticators/all',
        getById: 'authenticators/getById',
        favorites: 'authenticators/favorites',
        templateId: 'authenticators/templateId',
        okey: 'settings/okey',
        alwaysShowOtp: 'settings/showOtp',
        personalFolderId: 'authenticators/personalFolderId',
      }),
      favoriteFeature() {
        return (this.okey || this.favorites.length >= 1) || !this.offlineMode;
        // return (!this.offlineMode && this.okey && this.personalFolderId) || this.favorites.length >= 1;
      },
      canFavorite() {
        return this.okey || !this.offlineMode;
        // return (!this.offlineMode && this.okey && this.personalFolderId) || this.favorites.length >= 1;
      },
      secret() {
        return this.getById(this.secretId);
      },
      showOtp() {
        return this.otp || this.alwaysShowOtp;
      },
      favorited() {
        return this.favorites.includes(this.secret.id);
      },
      mask() {
        if (this.secret.otp) {
          if (this.showOtp) {
            return this.secret.otp;
          }
          return '******';
        }
        return this.secret.otp;
      },
    },
    methods: {
      ...mapActions({
        generateOtp: 'authenticators/generateOtp',
        setLoading: 'loading/setLoading',
        setDelayedFeedback: 'feedback/setDelayedFeedback',
        toggleFavorite: 'authenticators/toggleFavorite',
      }),
      toggleShowOtp() {
        this.otp = !this.otp;
      },
      secretUrl(id) {
        return this.url + '/SecretView.aspx?secretid=' + id;
      },
      generateOtps() {
        if (this.secretId) {
          this.dispatched = true;
          this.$store.dispatch('authenticators/generateOtp', this.secretId);
        }
      },
      fieldType() {
        return 'text';
        // if (this.showOtp || this.alwaysShowOtp) {
        //   return 'text';
        // }
        // return 'password';
      },
      copy(id) {
        if (this.secrets[id].otp === 'undefined') {
          Toastr.error('Unable to copy.');
          return false;
        }
        return this.clip(this.secrets[id].otp);
      },
      clip(str) {
        const el = document.createElement('textarea');
        el.value = str;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        const selected = document.getSelection().rangeCount > 0 ? document.getSelection()
          .getRangeAt(0) : false;
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        if (selected) {
          document.getSelection()
            .removeAllRanges();
          document.getSelection()
            .addRange(selected);
          Toastr.success('One Time Password copied');
        }
      },
      favorite() {
        if (this.canFavorite) {
          this.toggleFavorite(this.secret.id);
        }
      }
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/pages/Authenticator.vue